<template>
    <v-card>
        <v-card-title>
            <span class="headline">Generate SPK</span>
        </v-card-title>
        <v-card-text>
            <v-container>
                <v-row>
                <v-subheader class="title pl-0">LP</v-subheader>
            </v-row>
                <v-row>
                    <v-col cols="12" class="card-add-container">
                        <v-row v-for="(item, i) in formSpkLp" :key="'item-' + i">
                            <v-col cols="12" class="p-relative">
                                <div class="number-uraian">
                                    {{i+1}}.
                                </div>
                                <v-col cols="6" class="pl-0">
                                    <v-text-field v-model="formSpkLp[i].nama" label="Header uraian pekerjaan" outlined />
                                </v-col>
                                <v-btn class="mx-2 mt-6 btn-delete-uraian"  :hidden="i === 0" color="red" fab x-small @click="remove(i, 'LP')"> <v-icon>mdi-minus</v-icon></v-btn>
                            </v-col>
                            <v-col class="card-add">
                                <v-row v-for="(item_child, j) in item.spk_pekerjaan" :key="'item-child-' + j">
                                    <v-col cols="1" class="w-20">
                                        <div class="number-uraian-list">
                                            {{j+1}}.
                                        </div>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-text-field v-model="item_child.nama" label="List Uraian" />
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="item_child.quantity" label="Quantity" />
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="item_child.satuan" label="Satuan (Rp)" />
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="item_child.hargaSatuan" label="Harga Satuan (Rp)" />
                                    </v-col>
                                    <v-btn class="mx-2 mt-6"  :hidden="j === 0" color="red" fab x-small @click="removeUraian(i,j, 'LP')"> <v-icon>mdi-minus</v-icon></v-btn>
                                </v-row>
                                <v-col> <v-btn class="mx-2 float-right" color="cyan" @click="addUraianItem(i, 'LP')">Tambah List Uraian</v-btn> </v-col>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="pl-0"> <v-btn class="mx-2 ml-0" color="cyan" @click="addUraian('LP')">Tambah LP</v-btn> </v-col>
                </v-row>
                <v-row>
                    <v-subheader class="title pl-0 mt-10">LNP</v-subheader>
                </v-row>
                <v-row>
                    <v-col cols="12" class="card-add-container">
                        <v-row v-for="(item, i) in formSpkLnp" :key="'item-' + i">
                            <v-col cols="12" class="p-relative">
                                <div class="number-uraian">
                                    {{i+1}}.
                                </div>
                                <v-col cols="6" class="pl-0">
                                    <v-text-field v-model="formSpkLnp[i].nama" label="Header uraian pekerjaan" outlined />
                                </v-col>
                                <v-btn class="mx-2 mt-6 btn-delete-uraian"  :hidden="i === 0" color="red" fab x-small @click="remove(i, 'LNP')"> <v-icon>mdi-minus</v-icon></v-btn>
                            </v-col>
                            <v-col class="card-add">
                                <v-row v-for="(item_child, j) in item.spk_pekerjaan" :key="'item-child-' + j">
                                    <v-col cols="1" class="w-20">
                                        <div class="number-uraian-list">
                                            {{j+1}}.
                                        </div>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-text-field v-model="item_child.nama" label="List Uraian" />
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="item_child.quantity" label="Quantity" />
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field type="number" v-model="item_child.satuan" label="Satuan (Rp)" />
                                    </v-col>
                                    <v-col cols="2">
                                        <v-text-field v-model="item_child.hargaSatuan" label="Harga Satuan (Rp)" />
                                    </v-col>
                                    <v-btn class="mx-2 mt-6"  :hidden="j === 0" color="red" fab x-small @click="removeUraian(i,j, 'LNP')"> <v-icon>mdi-minus</v-icon></v-btn>
                                </v-row>
                                <v-col> <v-btn class="mx-2 float-right" color="cyan" @click="addUraianItem(i, 'LNP')">Tambah List Uraian</v-btn> </v-col>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col class="pl-0"> <v-btn class="mx-2 ml-0" color="cyan" @click="addUraian('LNP')">Tambah LNP</v-btn> </v-col>
                </v-row>
            </v-container>
        </v-card-text>
        <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1"
                   class="mt-10 mb-10 mr-10"
                   text
                   @click="submitForm"
            >
                Save</v-btn>
            <v-btn color="blue darken-1"
                   class="mt-10 mb-10 mr-10"
                   text
                   @click="downloadSpk"
            >
                Download</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    const axios = require('axios').default;
    const apiUrl = process.env.VUE_APP_ROOT_API
    export default {
        name: "Spks",
        data()  {
            return {
                formSpkLp:[
                    {
                        id:0,
                        nama: "",
                        tipeBiaya:"LP",
                        spk_pekerjaan:
                            [
                                {
                                    id:0,
                                    nama: "",
                                    quantity: 0,
                                    satuan: 0,
                                    hargaSatuan: 0
                                }
                            ]
                    },
                ],
                formSpkLnp:[
                    {
                        id:0,
                        nama: "",
                        tipeBiaya:"LNP",
                        spk_pekerjaan:
                            [
                                {
                                    id:0,
                                    nama: "",
                                    quantity: 0,
                                    satuan: 0,
                                    hargaSatuan: 0
                                }
                            ]
                    }
                ],
            }
        },

        computed: {
            paket: function() {
            return this.$store.getters['lelang/paket']
            },
        },

        methods: {
            addUraianItem(i, type) {
                if( type === "LP"){
                    this.formSpkLp[i].spk_pekerjaan.push({
                        id:0,
                        nama: "",
                        quantity: 0,
                        satuan: 0,
                        hargaSatuan: 0
                    })
                } else {
                    this.formSpkLnp[i].spk_pekerjaan.push({
                        id:0,
                        nama: "",
                        quantity: 0,
                        satuan: 0,
                        hargaSatuan: 0
                    })
                }
            },

            remove(i, type) {
                if( type === "LP"){
                    this.formSpkLp.splice(i, 1);
                } else {
                    this.formSpkLnp.splice(i, 1);
                }
            },

            removeUraian(i,j, type) {
                if( type === "LP"){
                    this.formSpkLp[i].spk_pekerjaan.splice(j, 1);
                } else {
                    this.formSpkLnp[i].spk_pekerjaan.splice(j, 1);
                }
            },

            addUraian(type){
                if( type === "LP"){
                    this.formSpkLp.push(
                        {
                            id:0,
                            nama: "",
                            tipeBiaya:type,
                            spk_pekerjaan:
                                [
                                    {
                                        id:0,
                                        nama: "",
                                        quantity: 0,
                                        satuan: 0,
                                        hargaSatuan: 0
                                    }
                                ]
                        }
                    )
                } else {
                    this.formSpkLnp.push(
                        {
                            id:0,
                            nama: "",
                            tipeBiaya:type,
                            spk_pekerjaan:
                                [
                                    {
                                        id:0,
                                        nama: "",
                                        quantity: 0,
                                        satuan: 0,
                                        hargaSatuan: 0
                                    }
                                ]
                        }
                    )
                }
            },

            submitForm(){
                axios.post(apiUrl+"/api/spk", {
                    tenderId: this.paket.id,
                    spk: (this.formSpkLp.concat(this.formSpkLnp)).map( e => {
                        e.spk_pekerjaan = e.spk_pekerjaan.map( f => {
                            f.quantity = Number(f.quantity);
                            f.satuan = Number(f.satuan);
                            f.hargaSatuan = Number(f.hargaSatuan);
                            return f
                        });
                        return e
                    })
                })
                    .then( (response) => {
                        console.log(response)
                        this.notification = {
                            show: true,
                            color: "success",
                            text: "Data kegiatan berhasil ditambahkan"
                        }
                    })
                    .catch( (error) => {
                        this.notification = {
                            show: true,
                            color: "error",
                            text: `[${error.message}] Gagal menambahkan data kegiatan`
                        };
                    });
            },

            async downloadSpk(){
                await axios.get(`${apiUrl}/api/spk/pdf/${this.paket.id}`)
                    .then(response => {
                        console.log(response)
                        this.getLinkDownload(response.data.file)
                    })
                    .catch( (error) => {
                        console.log(error.response.data.message)
                    });
            },

            getLinkDownload: async function(dok) {
                await axios.get(`${apiUrl}/${dok}`, { responseType: 'blob' })
                .then(response => {
                    const blob = new Blob([response.data], { type: response.headers['content-type'] })
                    const link = document.createElement('a')
                    link.href = URL.createObjectURL(blob)
                    link.download = dok
                    link.click()
                    URL.revokeObjectURL(link.href)
                }).catch(console.error)
            },
        }
    }
</script>

<style scoped>
    .card-add-container{
        border: 1px solid rgba(0, 0, 0, 0.42);
        border-radius: 4px;
        padding: 15px 15px 15px 60px;
        position: relative;

        > div {
           border-bottom: 1px solid rgba(0, 0, 0, 0.42) !important;
        }
    }
    .w-20{
        width: 25px !important;
        max-width: 25px !important;
        padding: 1px;
    }
    .number-uraian{
        font-weight: bold;
        font-size: 14px;
        margin: 40px 0 0 10px;
        position: absolute;
        left: -25px;
    }
    .number-uraian-list{
        font-weight: bold;
        font-size: 14px;
        margin: 40px 0 0 10px;

    }
    .card-add{
        border: 1px solid rgba(0, 0, 0, 0.42);
        border-radius: 4px;
        margin: 15px;
        padding: 10px;
    }

    .btn-delete-uraian{
        position: absolute;
        top: 25px;
        right: 25px;
    }

    .p-relative{
        position: relative;
    }
</style>